import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import "assets/css/grid_table.css";
import moment from "moment";
import numeral from "numeral";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";

const PollDataInterfaceRuns = () => {
  let emptyRow = {
    poll_data_int_run_id: null,
    poll_date_begin_hour: "",
    job_name: "",
    ora_poll_data_int_run_id: null,
    machine_name: "",
    machine_code: "",
    dxp_file_prefix: "",
    process_id: null,
    process_name: "",
    production_line_number: null,
    ora_processed_flag: "",
    ora_error_message: null,
    num_of_data_rows: null,
    num_of_data_rows_processed: null,
    run_mins: null,
    num_of_data_columns: null,
    num_of_nonzero_data: null,
    created_by: null,
    creation_date: "",
    last_updated_by: null,
    last_update_date: ""
  };
  
  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loadingErrors, setLoadingErrors] = useState([]);
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
  const [machineName, setMachineName] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const toast = useRef(null);
  const [expandedRowId, setExpandedRowId] = useState([]);
  const [dtlMsgs, setDtlMsgs] = useState({});
  const [loadingRowId, setLoadingId] = useState(null);
  const dt = useRef(null);
  const dt1 = useRef(null);
  const prevExpanRef = useRef([])

  useEffect(() => {
    const fetchData = async () => {
      const yesterday = moment().subtract(1, "days").set({
        hour: 7,
        minute: 0,
        second: 0,
        millisecond: 0,
      });

      let formattedStartDate = yesterday.format("yyyy-MM-DD HH:mm");
      setStartDate(formattedStartDate);

      const tomorrow = moment().add(0, "days").set({
        hour: 6,
        minute: 59,
        second: 0,
        millisecond: 0,
      });
      let formattedEndDate = tomorrow.format("yyyy-MM-DD HH:mm");
      setEndDate(formattedEndDate);
    };

    fetchData();
  }, []);

  const handleLoadData = async () => {

    const p_param = {
      p_start_datetime: startDate,
      p_end_datetime: endDate,
      p_machine_name_like: machineName,
    };
    console.log(p_param);
    try {
      setIsLoading(true);
      const response = await loadApi(p_param, "/api/txn/getPollDataIntRun");
      console.log("Fetched Data:", response.data);
      console.log(response.data[0]);
      console.log(response.data[1]);
      if (response.data.length > 0) {
        let successFlag = response.data[0];
        if (successFlag === "Y") {
          toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
          console.log("success=Y");
          setRows(response.data[1]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(false);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
          const errorInfo = response.data[2];
          // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }
        //setSearch(response.data);
      } else {
        //setRows(null);
        setRows([]);
        setIsLoading(false);
        setWasDataFetchingSuccessful(true);
      }

      //setRows(response.data);
    } catch (error) { 
      if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const hideDialog = () => {
    setRowDialog(false);
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Poll Data Interface Runs</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const getLoadedHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="header-container">
        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
         Poll Data Interface Runs
              {/* <div className="header-container p-1">
              <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
          <span className="p-input-icon-right w-full md:w-auto"> 
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto text-sm p-3"
          style={{ fontSize: '17px' }} 
        />
      </span>
          </div> */}
          </h2>
        </div>
      </React.Fragment>
    );
  };
  const getErrrorMsgContents = () => {
    return (
      <React.Fragment>
        <div class="row mt-5 justify-content-md-center">
          <div class="col-3">
            <div class="card border-secondary">
              <div class="card-header bg-dark text-white">
                Poll Data Interface Runs table is Unavailable
              </div>
              <div class="card-body card-body-error rounded-bottom">
                <ul>
                  {loadingErrors.map((error) => (
                    <li>error</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const getSearchControls = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Search</label>
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          disabled={isLoading}
          className="input-outline"
        />
      </div>
    </React.Fragment>
  );
  
  const getMachineNameControl = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Machine Name</label>
        <InputText
          type="text"
          id="MacName"
          name="MacName"
          onChange={(e) => setMachineName(e.target.value)}
          placeholder="Enter machine name"
          disabled={isLoading}
          className="input-outline"
        />
      </div>
    </React.Fragment>
  );

  const getStartEndDateControls = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Start Date</label>
        <div className="input-group date input-wrapper">
        <input
          type="datetime-local"
          id="StartDateTime"
          name="StartDateTime"
          value={startDate}
          onChange={handleStartDateChange}
          disabled={isLoading}
          className="input-outline1"
        />
        </div>
      </div>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">End Date</label>
        <div className="input-group date input-wrapper">
        <input
          type="datetime-local"
          id="EndDateTime"
          name="EndDateTime"
          value={endDate}
          onChange={handleEndDateChange}
          disabled={isLoading}
          className="input-outline1"
        />
        </div>
      </div>
    </React.Fragment>
  );

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const getGoButtonControl = () => (
    <React.Fragment>
      <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
        <button
          type="button"
          className="btn btn-primary load-button"
          id={"chartAreaId"}
          onClick={handleLoadData}
          disabled={isLoading}
        >
           <i
            className={
              isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
            }
          ></i>
          <span>{isLoading ? "Loading" : "Go"}</span>
        </button>
      </div>
    </React.Fragment>
  );

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );
  const pollDateBeginHourTemplate = (rowData) => {
     return rowData.poll_date_begin_hour ? moment.utc(rowData.poll_date_begin_hour).format("YYYY-MM-DD HH:mm:ss") : null;
  };

  const creationDateTemplate = (rowData) => {
    return rowData.creation_date ? moment.utc(rowData.creation_date).format("YYYY-MM-DD HH:mm:ss") : null;
  };
  const lastUpdateDateTemplate = (rowData) => {
    return rowData.last_update_date ? moment.utc(rowData.last_update_date).format("YYYY-MM-DD HH:mm:ss") : null;
  };

  const numOfDataRowsProcessedTemplate = (rowData) => {
    return numeral(rowData.num_of_data_rows_processed).format("0,0");
  };
  const numOfDataColumnsTemplate = (rowData) => {
    return numeral(rowData.num_of_data_columns).format("0,0");
  };
  const numOfNonZeroDataTemplate = (rowData) => {
    return numeral(rowData.num_of_nonzero_data).format("0,0");
  };
  const numOfProdLineNoTemplate = (rowData) => {
    return numeral(rowData.production_line_number).format("0,0");
  };
  const runMinsTemplate = (rowData) => {
    return numeral(rowData.run_mins).format("0.00");
  };

  const pollDateBeginHour = row.poll_date_begin_hour ? moment.utc(row.poll_date_begin_hour).format("YYYY-MM-DD HH:mm:ss") : null;
  const creationDate = row.creation_date ? moment.utc(row.creation_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const lastUpdateDate = row.last_update_date ? moment.utc(row.last_update_date).format("YYYY-MM-DD HH:mm:ss") : null;

  const numOfDataRowsProcessedNumber = numeral(row.num_of_data_rows_processed).format("0,0");
  const numOfDataColumnsNumber = numeral(row.num_of_data_columns).format("0,0");
  const numOfNonZeroDataNumber = numeral(row.num_of_nonzero_data).format("0,0");
  const numOfProdLineNoNumber = numeral(row.production_line_number).format("0,0");
  const runMinsNumber = numeral(row.run_mins).format("0.00");

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

    const fetchDtlMsgs = async (poll_data_int_run_id) => {
      setIsLoading1(true);
      setLoadingId(poll_data_int_run_id);
      const p_param = {
        p_poll_data_int_run_id: poll_data_int_run_id,
      };
      console.log(p_param);
      try {
        const response = await loadApi(
          p_param,
          "/api/txn/getPollDataIntRunDtl"
        );
        console.log("Fetched DtlMsgs:", response.data);
  
        if (response.data.length > 0) {
          const successFlag = response.data[0];
          if (successFlag === "Y") {
            setDtlMsgs((prevDtlMsgs) => ({
              ...prevDtlMsgs,
              [poll_data_int_run_id]: response.data[1],
            }));
            setIsLoading1(false);
          } else {
            setDtlMsgs((prevDtlMsgs) => ({
              ...prevDtlMsgs,
              [poll_data_int_run_id]: [],
            }));
          }
        } else {
          setDtlMsgs((prevDtlMsgs) => ({ ...prevDtlMsgs, [poll_data_int_run_id]: [] }));
          setIsLoading1(false);
        }
      } catch (error) {
        console.error("Error fetching dtlMsgs:", error);
      } finally {
        setIsLoading1(false);
        setLoadingId(null);
      }
    };
  
    useEffect(() => {
      const prevExpanded = prevExpanRef.current;
        const newlyExpanded = expandedRowId.filter((id) => !prevExpanded.includes(id))
        newlyExpanded.forEach((poll_data_int_run_id) => {
        if(poll_data_int_run_id) {
          fetchDtlMsgs(poll_data_int_run_id);
        }
      });
      prevExpanRef.current = expandedRowId;
    }, [expandedRowId])
   
  
    const drillDownTemplate = (rowData) => {
      const isExpanded = expandedRowId.includes(rowData.poll_data_int_run_id);
  
      return (
        <Button
          icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
          className={`p-button-rounded p-button-sm ${
            isExpanded ? "p-button-danger" : "p-button-primary"
          }`}
          onClick={() => toggleRowExpansion(rowData.poll_data_int_run_id)}
          tooltip="Detail"
          tooltipOptions={{ position: "bottom" }}
          style={{ fontSize: "1rem" }}
        />
      );
    };

    const toggleRowExpansion = (rowId) => {
        setExpandedRowId((prevExpandedRowId) =>
          prevExpandedRowId.includes(rowId)
            ? prevExpandedRowId.filter((id) => id !== rowId)
            : [...prevExpandedRowId, rowId]
        );
      };
    
      const rowExpansionTemplate = (data) => {
        const dtlMsgsData = dtlMsgs[data.poll_data_int_run_id] || [];
        const exportCSV1 = () => {
          dt1.current.exportCSV();
        };
    
        return (
          <div className="p-3">
            {loadingRowId == data.poll_data_int_run_id && (<h6>The data is loading...</h6>)}
            {loadingRowId != data.poll_data_int_run_id && (<>
            <div className="header-container">
              <div className="header-container p-1">
                <style>
                  {`
                    input::placeholder {
                      font-size: 17px;
                    }
                  `}
                </style>
                <span className="p-input-icon-right w-full md:w-auto">
                  <InputText
                    type="search"
                    onInput={(e) => setGlobalFilter1(e.target.value)}
                    placeholder="Search..."
                    className="w-full lg:w-auto text-sm p-3"
                    style={{ fontSize: "17px" }}
                  />
                </span>
                <Button
                  icon="pi pi-upload"
                  className="p-button-primary p-button-rounded"
                  onClick={exportCSV1}
                  tooltip="Export"
                  tooltipOptions={{ position: "bottom" }}
                  style={{ marginLeft: "20px", marginBottom: "10px" }}
                />
                <span style={{marginLeft: "20px"}}>
                  <b>No. of Rows :</b> {dtlMsgsData.length}
                </span>
              </div>
            </div>
            <DataTable
              ref={dt1}
              value={dtlMsgsData}
              responsiveLayout="scroll"
              globalFilter={globalFilter1}
            >
              <Column field="seq_number" header="Seq Number" sortable></Column>
              <Column
                field="creation_date"
                header="Creation Date"
                sortable
              ></Column>
              <Column
                field="msg"
                header="Msg"
                sortable
              ></Column>
            </DataTable>
            </>
            )}
          </div>
        );
      };

   const CardComponent = ({title, data}) => {
      const rightAlignedLabels = ["#Of Data Rows : ", "#Of Columns : ", "#Of Non-zero data : ", "Ln# : ", "Run Mins : "]

      return (
        <Card className="card-containers">
          <h5  style={{"fontWeight":"bold"}}> {title} </h5>
          <Divider className="my-2" />
          {data.map((item, index) => (
            <div key={index} className="label-value-pair">
              <span className="label">{item.label}</span>
              
              {item.label &&
              <span         
              className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                {item.value}</span>
              }
              
            </div>
          ))}
        </Card>
      )
    }

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
        {getLoadedHeaderContents()}
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              {getSearchControls()}
              {getStartEndDateControls()}
              {getMachineNameControl()}
              {getGoButtonControl()}
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
                {/* <div className="text-3xl text-800 font-bold mb-4">Poll Data Interface Runs</div> */}
                <DataTable
                  ref={dt}
                  value={rows}
                  scrollable
                  scrollHeight="flex"
                  selection={selectedRows}
                  onSelectionChange={(e) => setSelectedRows(e.value)}
                  dataKey="poll_data_int_run_id"
                  className="custom-datatable-border"
                  tableStyle={{ minWidth: "50rem" }}
                  paginator
                  rows={pecaPageRows}
                  rowsPerPageOptions={pecaRowsPerPageOptions}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
                  globalFilter={globalFilter}
                  header={header}
                  emptyMessage="No data found"
                  stripedRows
                  showGridlines
                  expandedRows={expandedRowId.map((poll_data_int_run_id) =>
                  rows.find((rows) => rows.poll_data_int_run_id === poll_data_int_run_id)
                  )}
                  onRowToggle={(e) => {
                  const rowId = e.data ? e.data.poll_data_int_run_id : null;
                  setExpandedRowId((prev) =>
                  prev.includes(rowId)
                    ? prev.filter((poll_data_int_run_id) => poll_data_int_run_id !== rowId)
                    : [...prev, rowId]
                  );
                  }}
              rowExpansionTemplate={rowExpansionTemplate}
                >
                  <Column
                    body={readBodyTemplate}
                    exportable={false}
                    style={{ width: "0.75rem" }}
                  ></Column>
                  <Column
                    body={drillDownTemplate}
                    style={{ width: "3rem", textAlign: "center" }}
                  />
                  <Column
                    field="job_name"
                    header="Job Name"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="poll_data_int_run_id"
                    header="Poll Data Int Run ID"
                    hidden="true"
                    exportable={false}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right"  }}
                  ></Column>
                  <Column
                    field="poll_date_begin_hour"
                    header="Data Begin Time"
                    sortable
                    body={pollDateBeginHourTemplate}
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="num_of_data_rows_processed"
                    header="#Of Data Rows Processed"
                    sortable
                    body={numOfDataRowsProcessedTemplate}
                    style={{ whiteSpace: "nowrap", textAlign: "right"  }}
                  ></Column>
                  <Column
                    field="run_mins"
                    header="Run Mins"
                    sortable
                    body={runMinsTemplate}
                    style={{ whiteSpace: "nowrap", textAlign: "right"  }}
                  ></Column>
                  <Column
                    field="num_of_data_columns"
                    header="#Of Columns"
                    sortable
                    body={numOfDataColumnsTemplate}
                    style={{ whiteSpace: "nowrap", textAlign: "right"  }}
                  ></Column>
                  <Column
                    field="num_of_nonzero_data"
                    header="#Of Non-zero data"
                    sortable
                    body={numOfNonZeroDataTemplate}
                    style={{ whiteSpace: "nowrap", textAlign: "right"  }}
                  ></Column>

                  <Column
                    field="ora_poll_data_int_run_id"
                    header="Ora Machine Id"
                    sortable
                    hidden="true"
                    exportable={false}
                  ></Column>
                  <Column
                    field="machine_name"
                    header="Machine Name"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="machine_code"
                    header="Machine Code"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ora_processed_flag"
                    header="Ora Processed ?"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ora_error_message"
                    header="Ora Errors"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="process_id"
                    header="Process Id"
                    sortable
                    hidden="true"
                    style={{ whiteSpace: "nowrap"}}
                  ></Column>
                  <Column
                    field="process_name"
                    header="Process"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>

                  <Column
                    field="production_line_number"
                    header="Ln#"
                    sortable
                    body={numOfProdLineNoTemplate}
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="creation_date"
                    header="Creation Date"
                    sortable
                    body={creationDateTemplate}
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="last_update_date"
                    header="Last Update Date"
                    sortable
                    body={lastUpdateDateTemplate}
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                </DataTable>
              </div>
            )}
          </div>
        </div>
       <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                 <h4 style={{"fontWeight":"bold"}}> Poll Data Interface Runs </h4>
                 <Divider className="my-4" />
                 <h5 style={{"fontWeight":"bold"}}> View Poll Data Interface Runs </h5>
                 <Divider className="my-4" />
                 <div className="card-wrapper">
                   <CardComponent
                     title="Job Info"
                     data={[
                       {label:"Job Name : ", value: row.job_name },
                       {label:"Data Begin Time : ", value: pollDateBeginHour },
                       {label:"#Of Data Rows : ", value: numOfDataRowsProcessedNumber },
                       {label:"Run Mins : ", value: runMinsNumber },
                       {label:"#Of Columns : ", value: numOfDataColumnsNumber },
                       {label:"#Of Non-zero data : ", value: numOfNonZeroDataNumber }
                     ]}
                   />
                   <CardComponent
                     title="Machine Info"
                     data={[
                       {label:"Machine Name : ", value: row.machine_name },
                       {label:"Machine Code : ", value: row.machine_code },
                       {label:"Ora Processed ? : ", value: row.ora_processed_flag },
                       {label:"Ora Errors : ", value: row.ora_error_message },
                       {label:"Process : ", value: row.process_name },
                       {label:"Ln# : ", value: numOfProdLineNoNumber }
                     ]}
                   />
                   <CardComponent
                     title="Oracle Interface Info"
                     data={[
                       {label:"Creation Date : ", value: creationDate },
                       {label:"Last Update Date : ", value: lastUpdateDate }
                     ]}
                   />
                  </div>
             </Dialog>
             <Dialog 
                 header="API Error" 
                 visible={errorDialogVisible} 
                 style={{ width: '400px' }} 
                 onHide={hideDialog} 
                 footer={
                     <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                 }
             >    
              <p>
 
                     {errorMessage}
                 </p>
             </Dialog>
             <style jsx>{`
               .card-wrapper {
                 display: grid;
                 grid-template-columns: repeat(3,1fr);
                 gap: 10px;
                 padding: 5px;
               }
 
               .card-containers {
                 display: flex;
                 background-color: #f9f9f9;
                 flex-direction: column;
                 justify-content: flex-start;
                 border: 1px solid #ccc;
                 paddig: 10px;
                 box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                 height: auto;
                 width: 100%;
               }
 
               .label-value-pair {
                 display: flex;
                 flex-direction: row,
                 align-items: flex-start;
                 gap: 5px;
                 margin-bottom: 8px;
                 flex-wrap: wrap;
               }
 
               .label {
                 font-weight: bold;
                 white-space: nowrap;
               }
 
               .value-box {
                 background-color:rgb(235, 235, 235);
                 padding: 6px 10px;
                 border-radius: 4px;
                 display: block;
                 word-wrap: break-word;
                 overflow-wrap: break-word;
                 flex-grow: 1;
                 min-width: 0;
               }
 
               .align-right {
                 text-align: right;
                 background-color:rgb(235, 235, 235);
                 padding: 6px 10px;
                 border-radius: 4px;
                 display: block;
                 word-wrap: break-word;
                 overflow-wrap: break-word;
                 flex-grow: 1;
                 min-width: 0;
               }
             `}
             </style>
             </div>
    </div>
  );
};

export default PollDataInterfaceRuns;
